<template>
  <div class="registry-box">
    <div class="top-icon">
      <img src="@/assets/logo_gold.png" @click.stop="toHome" />
    </div>
    <div class="user-pannel">
      <div class="re-title">Forgot Password</div>

      <div v-if="isSendEmail" class="form-box">
        <el-form
          :model="emailRegistryForm"
          ref="emailRegistryForm"
          :rules="emailRegistryFormRules"
        >
          <el-form-item label="Email address" prop="login_name">
            <el-input
              v-model.trim="emailRegistryForm.login_name"
              placeholder="Enter an email address"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="regist-bt-box">
          <div v-loading="resetLoading" class="regist-bt" @click="sendEmail">
            Send Email
          </div>
        </div>
        <div class="re-tips">
          Remember the password? <a href="/#/">Log in</a>
        </div>
      </div>
      <div v-else class="tips-box">
        <i class="el-icon-success"></i>
        <div>
          Please visit the link address given in the email and follow the
          instructions on the page to complete the password reset.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../Sys/User.vue";
import { isEmail } from "@/utils/validate";
import { Md5ChangePass } from "@/utils/comm";
import { mapState, mapGetters } from "vuex";
export default {
  components: {},
  computed: {},
  data() {
    return {
      emailRegistryForm: {},
      emailRegistryFormRules: {
        login_name: {
          required: true,
          message: "Email is required",
          trigger: "blur",
        },
      },
      isSendEmail: true,
      resetLoading: false,
    };
  },
  methods: {
    async sendEmail() {
      this.$refs.emailRegistryForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.resetLoading = true;
        const { status, message } = await this.$api.userApi.resetPwdEmail(
          this.emailRegistryForm
        );
        if (status === "0") {
          this.isSendEmail = false;
        }
        this.$message({
          type: status === "0" ? "success" : "error",
          message: message,
        });
        this.resetLoading = false;
      });
    },
    toHome() {
      this.$router.push("home");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.registry-box {
  min-height: 100vh;
  background: #fce9d1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: vw(28);
  box-sizing: border-box;
  .top-icon {
    text-align: center;
    padding: 28px;
    cursor: pointer;
    img {
      width: 113px;
      height: 40px;
    }
  }
  .user-pannel {
    width: vw(600);
    // height: vw(625);
    background: #fff;
    margin-top: vw(60);
    text-align: center;
    border-radius: 24px;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
    padding: vh(50) 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    .form-box {
      width: vw(360);
      margin: vh(30) 0 vh(10) 0;
    }
    .tips-box {
      width: vw(360);
      margin: vh(60) 0 vh(20) 0;
      text-align: left !important;
      color: #201002;
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .el-icon-success {
        font-size: 36px;
        color: #f48c06;
        margin-right: vw(15);
      }
    }
    .el-form {
      margin-top: vw(16);
      width: 100%;
    }
    .el-form-item {
      margin-bottom: vw(32);
      .forgot-password {
        cursor: pointer;
        float: right;
        font-size: 14px;
        font-weight: 600;
        color: #f48c06;
        line-height: 20px;
      }
      /deep/ .el-input__inner {
        // width: vw(360);
        width: 100%;
      }
    }
    /deep/ .el-form-item.is-error .el-input__inner {
      border-color: #f42506 !important;
    }
    /deep/ .el-form > .el-form-item > .el-form-item__label {
      //label样式
      font-size: 14px;
      font-weight: 600;
      color: #201002;
      line-height: 20px;
    }
    /deep/ .el-form > .el-form-item > .el-form-item__content {
      line-height: 100%;
      .el-input {
        margin-top: vw(8);
        .el-input__inner {
          height: vw(48);
          border-radius: 8px;
          border: 2px solid rgba(32, 16, 2, 0.32);
        }
      }
      .el-select {
        width: 100%;
      }
      .el-form-item__error {
        font-size: vw(14);
        font-weight: 600;
        color: #f42506;
      }
    }
    .re-title {
      font-weight: 600;
      color: #201002;
      line-height: vw(66);
      font-size: vw(48);

      font-family: "PingFangSC-Semibold", "PingFang SC";
    }

    .regist-bt-box {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .regist-bt {
      width: vw(360);
      height: vw(48);
      font-size: vw(14);
      font-weight: 600;
      border-radius: 8px;
      cursor: pointer;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f48c06;
      &:hover {
        opacity: 0.54;
      }
    }
    .re-tips {
      font-size: vw(18);
      font-weight: 500;
      color: #201002;
      line-height: vw(28);
      margin-top: vw(32);
      a:hover {
        color: #f48c06;
        text-decoration: none;
      } /* 鼠标悬浮在上的链接 蓝色 */
    }
  }
}
</style>
